export default class {
  constructor (iban) {
    this.iban = iban ? iban.iban : ''
    this.bic = iban ? iban.bic : ''
  }
}
